import React, { useEffect, useMemo, useRef, useState } from "react";
import ReactPaginate from "react-paginate";
import { useDispatch, useSelector } from "react-redux";
// import { allapiAction } from "../../../Redux/common/action";
// import { URL } from "../../../Redux/common/url";
// import Footer from "../Layout/Footer";
// import Header from "../Layout/Header";
// import Sidebar from "../Layout/Sidebar";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Select from "react-select";
import moment from "moment";

import ImageUploading from "react-images-uploading";
import { toast } from "react-toastify";
// import dateFormat, { masks } from "dateformat";

import ReactToPrint from "react-to-print";
import { allapiAction } from "../../Redux/common/action";
import HeaderAccount from "../Layout/HeaderAccount";
import Sidebar from "../Layout/Sidebar";
import { URL } from "../../Redux/common/url";
// import { allapiAction } from "@/Redux/common/action";
// import { URL } from "@/Redux/common/url";
// import Header2 from "../../../component/sidebar/Header2";
// import Sidebar from "../../../component/sidebar/Sidebar";

function Order() {
  const dispatch = useDispatch();

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // getsellerProductList

  const get_seller_product_list = useSelector((state) =>
    state?.allapi?.order_list_user ? state?.allapi?.order_list_user : {},
  );
  const get_invoice = useSelector((state) =>
    state?.allapi?.get_invoice ? state?.allapi?.get_invoice : {},
  );
  const order_details = useSelector((state) =>
    state?.allapi?.order_details ? state?.allapi?.order_details : {},
  );

  const prohavenew = order_details?.product_details
    ? JSON.parse(order_details?.product_details)
    : {};
  const prohavenewaddress = order_details?.shipping_address
    ? JSON.parse(order_details?.shipping_address)
    : {};

  const oldproductshowincoice = Object.keys(prohavenew)
    .filter(
      (key) =>
        prohavenew[key] &&
        typeof prohavenew[key] === "object" &&
        !Array.isArray(prohavenew[key]),
    )
    .map((key) => prohavenew[key]);
  console.log(prohavenew);
  console.log(oldproductshowincoice);
  const all_sub_sub_categ_List = useSelector((state) =>
    state?.allapi?.all_sub_sub_categ_List
      ? state?.allapi?.all_sub_sub_categ_List
      : [],
  );
  const get_footer_all_data = useSelector((state) =>
    state?.allapi?.get_footer_all_data
      ? state?.allapi?.get_footer_all_data
      : {},
  );

  useEffect(() => {
    dispatch(allapiAction.getuserOrder(1));
    dispatch(allapiAction.getInvoice({}));
    dispatch(allapiAction.footerPagepageListetPu({}));

    return () => {};
  }, []);

  // useEffect(() => {
  //   dispatch(allapiAction.getsubsubcate({}));
  //   return () => {};
  // }, []);

  // const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(1);
  const [itemsPerPage, setitemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });
  const headers = [
    { name: "Route Name", field: "routeName", sortable: true },
    { name: "From", field: "from", sortable: true },
    { name: "To", field: "to", sortable: false },
    { name: "Action", field: "action", sortable: false },
  ];

  const comments = get_seller_product_list?.docs
    ? get_seller_product_list?.docs
    : [];

  const pageCount = get_seller_product_list?.totalPages
    ? get_seller_product_list?.totalPages
    : 0;

  const commentsData = useMemo(() => {
    let computedComments = comments;

    // if (search) {
    //   computedComments = computedComments.filter(
    //     (comment) =>
    //       comment.message.toLowerCase().includes(search.toLowerCase()) ||
    //       comment.title.toLowerCase().includes(search.toLowerCase())
    //   );
    // }

    if (sorting.field) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field]),
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * itemsPerPage,
      (currentPage - 1) * itemsPerPage + itemsPerPage,
    );
  }, [comments, currentPage, search, sorting, itemsPerPage]);

  // useEffect(() => {
  //   const endOffset = itemOffset + itemsPerPage;

  //   setPageCount(Math.ceil(get_seller_product_list.totalDocs / itemsPerPage));
  // }, [itemOffset, itemsPerPage, comments]);

  // const handlePageClick = (event: any) => {
  //   const newOffset = event.selected % (comments.length / 2)
  //   setCurrentPage(newOffset + 1)
  //   setItemOffset(newOffset * itemsPerPage)
  // }

  const [page, setpageNo] = useState(1);

  const handlePageClick = (event) => {
    // const newOffset = event.selected % (comments.length / 2);
    // setCurrentPage(newOffset + 1);
    // setItemOffset(newOffset * itemsPerPage);

    const data = event?.selected + 1;

    setpageNo(data);

    if (!search) {
      // dispatch(ShoetoggelAction.getusers(data))
      dispatch(allapiAction.getuserOrder(data));
      //   dispatch(allapiAction.getsellerProductList(1));
      return () => {};
    } else {
      // dispatch(
      //   ShoetoggelAction.searchUser({ pageNumber: data, key: userSearch })
      // );
      dispatch(allapiAction.searchSellerProduct({ key: search, page: data }));
      return () => {};
    }
  };

  // image uploder
  const [images, setImages] = React.useState([]);
  const maxNumber = 1;

  const onChange = (imageList, addUpdateIndex) => {
    // data for submit

    setImages(imageList);
  };

  const [images1, setImages1] = React.useState([]);
  const maxNumber1 = 4;

  const onChange1 = (imageList, addUpdateIndex) => {
    // data for submit

    setImages1(imageList);
  };

  const options = [
    { value: "chocolate", label: "Chocolate" },
    { value: "strawberry", label: "Strawberry" },
    { value: "vanilla", label: "Vanilla" },
  ];
  const [selectedOption, setSelectedOption] = useState(null);

  const [subList, setsubList] = useState([]);

  useEffect(() => {
    const dropList = all_sub_sub_categ_List?.map((data, i) => {
      data.value = data?._id;
      data.label = data?.name;

      return data;
    });

    setsubList(dropList);
  }, [all_sub_sub_categ_List]);

  const [roledata, setroledata] = useState({ title: "", tegs: "" });

  const hendleChangerole = (e) => {
    const { name, value } = e.target;
    setroledata({ ...roledata, [name]: value });
  };

  const hendleSearch = (e) => {
    // searchSellerProduct
    setSearch(e);
    // dispatch(allapiAction.searchSellerProduct(e));
    dispatch(allapiAction.searchSellerProduct({ key: e, page: 1 }));
    return () => {};
  };

  const submitProduct = () => {
    try {
      // const {data: auth} = await login(values.role_name, values.tegs)
      // saveAuth(auth)
      // const {data: user} = await getUserByToken(auth.api_token)
      // dispatch(adminAction.createRoles(values))
      const data = new FormData();

      // data.append("title", imageEditfor);

      // images

      if (images?.length == 0) {
        toast.error("please select feature Image");
      } else if (images1?.length == 0) {
        toast.error("please select  Image");
      } else if (!roledata?.title) {
        toast.error("please enter prodcat name");
      } else if (!roledata?.tegs) {
        toast.error("please enter product teg");
      } else if (!selectedOption) {
        toast.error("please select category ");
      } else {
        // setLoading(true);

        data.append("title", roledata?.title);
        data.append("tegs", roledata?.tegs);
        data.append("categoryName", "test cate");
        data.append("categoryId", selectedOption?._id);
        // data.append('sellerId', selectedOption1?._id)
        data.append("featureImage", images[0]?.file);
        images1?.forEach((file) => {
          data.append("images", file?.file);
        });

        dispatch(allapiAction.createSellerProduct(data));
        setShow(false);
        // setLoading(false);
      }

      // setCurrentUser(user)
    } catch (error) {
      // saveAuth(undefined)
      // setStatus('The login details are incorrect')
      // setSubmitting(false)
      // setLoading(false)
    }
  };

  // deleteSellerProduct

  const [showDelelt, setShowDelete] = useState(false);
  const [showDelelt1, setShowDelete1] = useState(false);
  const handleCloseDelete = () => setShowDelete(false);

  const [productID, setproductID] = useState("");

  const hendleModalShow = (e) => {
    setShowDelete(true);
    setproductID(e);

    dispatch(allapiAction.getuserOrderDetails({ _id: e?._id }));
    // dispatch(adminAction.getRoleList('dhsg'))
    return () => {};
  };

  const hendleDelete = () => {
    // deleteProduct
    setShowDelete(false);
    dispatch(allapiAction.deleteSellerProduct({ productId: productID }));
    // dispatch(adminAction.getRoleList('dhsg'))
    return () => {};
  };

  const componentRef = useRef();

  const hendleShowOrder = (e) => {
    // getuserOrderDetails

    dispatch(allapiAction.getuserOrderDetails({ _id: e }));
    // dispatch(adminAction.getRoleList('dhsg'))
    return () => {};
  };

  // get_invoice

  console.log(order_details);

  const shippingCharge = order_details?.sub_total > 10000 ? 699 : 199;
  console.log(order_details?.orderproductsList);

  const totalSubtotalPricegstdd = order_details?.orderproductsList?.reduce(
    (total, obj) => {
      return total + (obj.sub_total * obj?.gst) / 100;
    },
    0,
  );
  // return total +(obj.subtotalprice * obj?.gst) / 100 ;
  // console.log(shippingCharge)
  // console.log(totalSubtotalPricegstdd)

  const totalSubtotalPricegst = totalSubtotalPricegstdd;
  const totalAmount =
    order_details?.sub_total + shippingCharge + totalSubtotalPricegstdd;
  return (
    <div>
      <Sidebar />

      <main className="main-wrap ">
        <HeaderAccount />

        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Product Add</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {" "}
            <div className="card mx-auto ">
              <div className="card-body">
                {/* <h4 className="card-title mb-4">Feature Image</h4> */}

                <div className="mb-3">
                  <label for="product_name" className="form-label">
                    Feature Image
                  </label>
                  <ImageUploading
                    // multiple
                    value={images}
                    onChange={onChange}
                    maxNumber={maxNumber}
                    dataURLKey="data_url"
                    acceptType={["png", "jpeg", "jpg", "webp"]}
                  >
                    {({
                      imageList,
                      onImageUpload,
                      onImageRemoveAll,
                      onImageUpdate,
                      onImageRemove,
                      isDragging,
                      dragProps,
                    }) => (
                      // write your building UI
                      <div className="upload__image-wrapper">
                        <button
                          className="btn btn-primary btn-sm rounded"
                          style={isDragging ? { color: "red" } : undefined}
                          onClick={onImageUpload}
                          {...dragProps}
                        >
                          Click or Drop here
                        </button>
                        &nbsp;
                        <button
                          className="btn btn-primary btn-sm rounded"
                          onClick={onImageRemoveAll}
                        >
                          Remove all images
                        </button>
                        {imageList.map((image, index) => (
                          <div key={index} className="image-item">
                            <img src={image["data_url"]} alt="" width="100" />
                            <div className="image-item__btn-wrapper">
                              <button
                                className="btn btn-primary btn-sm rounded"
                                onClick={() => onImageUpdate(index)}
                              >
                                Update
                              </button>
                              <button
                                className="btn btn-primary btn-sm rounded"
                                onClick={() => onImageRemove(index)}
                              >
                                Remove
                              </button>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </ImageUploading>
                </div>
                <div className="mb-3">
                  <label for="title" className="form-label">
                    Product Name
                  </label>
                  <input
                    name="title"
                    className="form-control"
                    placeholder="Enter Product name"
                    type="text"
                    onChange={(e) => {
                      hendleChangerole(e);
                    }}
                  />
                </div>

                <div className="mb-3">
                  <label for="teg" className="form-label">
                    Product Tag
                  </label>
                  <input
                    name="tegs"
                    className="form-control"
                    placeholder="Enter tag"
                    type="text"
                    onChange={(e) => {
                      hendleChangerole(e);
                    }}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Select Category</label>
                  <Select
                    className="coustomSelect"
                    classNamePrefix="coustomSelect"
                    defaultValue={selectedOption}
                    onChange={setSelectedOption}
                    options={subList}
                  />
                  {/* <select className="form-select">
                  <option>Automobiles</option>
                  <option>home items</option>
                  <option>Electronics</option>
                  <option>Smartphones</option>
                  <option>Sport items</option>
                  <option>Baby and Tous</option>
                </select> */}
                </div>

                <div className="mb-3">
                  <label for="product_name" className="form-label">
                    Product Iamge
                  </label>
                  <ImageUploading
                    multiple
                    value={images1}
                    onChange={onChange1}
                    maxNumber={maxNumber1}
                    dataURLKey="data_url"
                    acceptType={["png", "jpeg", "jpg", "webp"]}
                  >
                    {({
                      imageList,
                      onImageUpload,
                      onImageRemoveAll,
                      onImageUpdate,
                      onImageRemove,
                      isDragging,
                      dragProps,
                    }) => (
                      // write your building UI
                      <div className="upload__image-wrapper">
                        <button
                          className="btn btn-primary btn-sm rounded"
                          style={isDragging ? { color: "red" } : undefined}
                          onClick={onImageUpload}
                          {...dragProps}
                        >
                          Click or Drop here
                        </button>
                        &nbsp;
                        <button
                          className="btn btn-primary btn-sm rounded"
                          onClick={onImageRemoveAll}
                        >
                          Remove all images
                        </button>
                        {imageList.map((image, index) => (
                          <div key={index} className="image-item">
                            <img src={image["data_url"]} alt="" width="100" />
                            <div className="image-item__btn-wrapper">
                              <button
                                className="btn btn-primary btn-sm rounded"
                                onClick={() => onImageUpdate(index)}
                              >
                                Update
                              </button>
                              <button
                                className="btn btn-primary btn-sm rounded"
                                onClick={() => onImageRemove(index)}
                              >
                                Remove
                              </button>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </ImageUploading>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                submitProduct();
              }}
            >
              Submit
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={showDelelt} size="lg" onHide={handleCloseDelete}>
          <Modal.Header closeButton>
            <Modal.Title> Invoice</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div
              id="kt_app_content"
              className="app-content flex-column-fluid"
              ref={componentRef}
            >
              <div class="container-fluid newinvoiceweiconinc shadow-sm p-3">
                <div class="row invoice-header align-items-center">
                  <div class="d-flex justify-content-between">
                    <div class="">
                      <h2 class="fw-bold">INVOICE</h2>
                      <p>INVOICE NO. {order_details?.sellCode}</p>
                    </div>
                    <div class="col-md-6 text-end ">
                      <div class="d-flex align-items-center justify-content-end">
                        <img
                          src="/weiconinclogo.png"
                          class="logowe me-2"
                          alt="Ril India Logo"
                        />
                        <span style={{ fontSize: "20px", fontWeight: "bold" }}>
                          Ril India
                        </span>
                      </div>
                      <p class="text-end">Gst No:07AALCR1095C1ZF</p>
                      <p class="text-end">
                        Amrit vihar street no 7 a block Burari north Delhi India
                        110084
                      </p>
                    </div>

                    {/* <div class="col-md-6 text-end">
                      <img
                        src="/weiconinclogo.png"
                        class="logowe"
                        alt="Ril India Logo"
                      />{" "}
                      <span style={{ fontSize: "20px", fontWeight: "bold" }}>
                        Ril India
                      </span>
                      <p>Gst No:07AALCR1095C1ZF</p>
                      <p>
                        Amrit vihar street no 7 a block Burari north Delhi India
                        110084
                      </p>
                    </div> */}
                  </div>
                </div>

                <hr class="invoice-border" />
                <div class="row mt-5">
                  <div class="d-flex justify-content-between">
                    <div class="">
                      Billed To:
                      <br />
                      {order_details?.shipping_address ? (
                        <strong>
                          {" "}
                          {prohavenewaddress?.firstname +
                            " " +
                            prohavenewaddress?.lastname}
                        </strong>
                      ) : (
                        <strong>{order_details?.user_id?.fullName}</strong>
                      )}
                      {/* <strong>Sumit Kumar</strong> */}
                      {order_details?.shipping_address ? (
                        <p class="d-inline">
                          {/* <br />
                    ZIP: {prohavenewaddress?.zip} */}
                          <br />
                          Phone: {prohavenewaddress?.phone}
                          <br />
                          E-mail: {prohavenewaddress?.email}
                        </p>
                      ) : (
                        <p class="d-inline">
                          {/* <br />
                    ZIP: {order_details?.address_id?.pincode} */}
                          <br />
                          Phone: {order_details?.address_id?.phone}
                          <br />
                          E-mail: {order_details?.address_id?.email}
                          <br />
                          {/* Monarch: {uplineListmq?.fullName} */}
                        </p>
                      )}
                      {/* <br />
                  9999999999
                  <br />
                  9999999@gmail.com
                  <br />
                  Monarch-
                  <br /> */}
                    </div>
                    <div class=" text-end">
                      Issued Date:
                      <br />
                      {/* mm/dd/yy */}
                      <strong>
                        {" "}
                        {moment(productID?.createdAt).format("MM/DD/YYYY")}{" "}
                      </strong>{" "}
                      <br />
                      Payment Status: <br />
                      <strong> Paid</strong>
                      <br />
                    </div>
                  </div>
                </div>

                <table class="table  invoice-table mt-4">
                  <thead class="table-light">
                    <tr>
                      <th>S.No.</th>
                      <th>Description</th>
                      <th>Colour</th>
                      <th>Size</th>
                      <th>Unit Cost</th>
                      <th>Quantity</th>
                      <th>Subtotal Amount</th>
                    </tr>
                  </thead>
                  <tbody class="">
                    {order_details?.orderproductsList &&
                      order_details?.orderproductsList?.map((data, i) => {
                        console.log(data);

                        return (
                          <tr
                            class="text-center"
                            style={{ borderBottom: "2px solid black" }}
                          >
                            <td className="">{i + 1}</td>
                            <td>
                              <div className="d-flex ">
                                <div className="">
                                  <div className="fw-bold">
                                    {data?.product_names}
                                  </div>
                                  <div className="fs-7 text-muted">
                                    {/* Delivery Date: 23/11/2022 */}
                                  </div>
                                </div>
                              </div>
                            </td>
                            {/* -end::Product-*/}
                            {/* -begin::SKU-*/}

                            <td className="text-end">
                              {" "}
                              {data?.colorId?.color}
                            </td>

                            <td className="text-end"> {data?.sizeId?.size}</td>

                            <td className="text-end"> {data?.product_price}</td>
                            {/* -end::SKU-*/}
                            {/* -begin::Quantity-*/}
                            <td className="text-end"> {data?.itme_count}</td>
                            {/* -end::Quantity-*/}
                            {/* -begin::Total-*/}
                            <td className="text-end">₹ {data?.sub_total}</td>
                            {/* -end::Total-*/}
                          </tr>
                        );
                      })}
                    {order_details?.product_details &&
                      oldproductshowincoice &&
                      oldproductshowincoice?.map((data, i) => {
                        console.log(data);

                        return (
                          <tr
                            class="text-center"
                            style={{ borderBottom: "2px solid black" }}
                          >
                            <td className="">{i + 1}</td>
                            <td>
                              <div className="d-flex ">
                                <div className="">
                                  <div className="fw-bold">{data?.name}</div>
                                  <div className="fs-7 text-muted">
                                    {/* Delivery Date: 23/11/2022 */}
                                  </div>
                                </div>
                              </div>
                            </td>
                            {/* -end::Product-*/}
                            {/* -begin::SKU-*/}
                            <td className="text-end">
                              {" "}
                              {data?.colorId?.color}
                            </td>
                            <td className="text-end"> {data?.sizeId?.size}</td>
                            <td className="text-end"> {data?.price}</td>
                            {/* -end::SKU-*/}
                            {/* -begin::Quantity-*/}
                            <td className="text-end"> {data?.qty}</td>
                            {/* -end::Quantity-*/}
                            {/* -begin::Total-*/}
                            <td className="text-end">₹ {data?.subtotal}</td>
                            {/* -end::Total-*/}
                          </tr>
                        );
                      })}
                    {/* <tr>
                  <td>1</td>
                  <td>T-shirt design</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>Flyer design</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>Brochure design</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>4</td>
                  <td>Banner design</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr> */}

                    <tr class="fw-bold">
                      <td class="bg-white border border-0"></td>
                      <td class="bg-white border border-0"></td>
                      <td colspan="" class="text-center">
                        Sub Total Amount:
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td> ₹ {order_details?.sub_total}</td>
                    </tr>
                    <tr class="fw-bold">
                      <td class="bg-white border border-0"></td>
                      <td class="bg-white border border-0"></td>
                      <td colspan="" class="text-center">
                        Tax:
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td>
                        {" "}
                        ₹{" "}
                        {oldproductshowincoice?.length == 0
                          ? totalSubtotalPricegst
                          : order_details?.vat}
                      </td>
                    </tr>
                    <tr class="fw-bold">
                      <td class="bg-white border border-0"></td>
                      <td class="bg-white border border-0"></td>
                      <td colspan="" class="text-center">
                        Shipping:
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td> ₹ {shippingCharge}</td>
                    </tr>
                    <tr class="fw-bold">
                      <td class="bg-white border border-0"></td>
                      <td class="bg-white border border-0"></td>
                      <td colspan="" class="text-center">
                        Grand Total:
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td>
                        {" "}
                        ₹{" "}
                        {oldproductshowincoice?.length == 0
                          ? totalAmount
                          : order_details?.totalAmount + shippingCharge}
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div class="row mt-4">
                  <div class="d-flex justify-content-between">
                    <div class="col-6">
                      <strong>Address Details:</strong>
                      <br />
                      {order_details?.shipping_address ? (
                        <p class="d-inline">
                          {prohavenewaddress?.address1},
                          <br />
                          Pincode: {prohavenewaddress?.zip}
                        </p>
                      ) : (
                        <p class="d-inline">
                          {order_details?.address_id?.address},
                          <br />
                          <strong>
                            {" "}
                            {order_details?.address_id?.city},
                            {order_details?.address_id?.state}
                          </strong>{" "}
                          <br />
                          Pincode: {order_details?.address_id?.pincode}
                        </p>
                      )}
                      {/* <strong>H.no:</strong> <br />
                  Larana, Inc.
                  <br />
                  <strong>distt, state details</strong> <br />
                  pincode
                  <br /> */}
                    </div>
                    <div class=" terms">
                      <strong>Terms & Conditions</strong>
                      <ul>
                        <li>
                          For Damaged product or item,please call our toll-free
                          number at 18004198684
                        </li>
                        <li>
                          Replacement that are defactive are subject to
                          restoking charges of 20%
                        </li>
                        <li>
                          In Order to recive a refund/replacement or to recive
                          credit product must be returned in 'saleable'
                          condition with the original packaging.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="d-flex justify-content-between my-5">
                  <div>
                    <img
                      width="24"
                      height="24"
                      src="https://img.icons8.com/ios-glyphs/30/phone-disconnected.png"
                      alt="phone-disconnected"
                    />
                    <span>18004198684</span>
                  </div>
                  <div>
                    <img
                      width="24"
                      height="24"
                      src="https://img.icons8.com/material-outlined/24/mail.png"
                      alt="mail"
                    />
                    <span>care@resolvedimprovelifeindia.com</span>
                  </div>
                  <div>
                    <img
                      width="24"
                      height="24"
                      src="https://img.icons8.com/ios-filled/50/domain.png"
                      alt="domain"
                    />
                    <span>www.RilIndia.biz</span>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="container img100" ref={componentRef}>
              <div className="row">
                <div className="col-lg-12">
                  <div class="p-1">
                    <div class="row px-5 mt-3">
                      <div class="col-sm-6">
                     
                        <p>{moment(new Date()).format("DD/MM/yyyy hh:mm A")}</p>
                      </div>

                      <div class="col-sm-6">
                        <p>Invoice | Ril India</p>
                      </div>
                    </div>
                    <br />
                    <br />
                    <br />
                    <br />
                    <div class="row px-5">
                      <div class="col-sm-6"></div>

                      <div class="col-sm-6">
                        <p>Invoice #:20240428342 Bill Code: #001176</p>
                        <p>Gst No:07AALCR1095C1ZF</p>
                        <p>Resolved Improve Life India Marketing Pvt. Ltd.</p>
                        <p>
                          Amrit vihar street no 7 a block Burari north Delhi
                          India 110084
                        </p>
                      </div>
                    </div>

                    <br />
                    <br />
                    <div class="row px-5">
                      <div class="col-sm-6">
                        <h3>Billed To. :</h3>
                        <p class="d-inline">
                          <b> Name:</b> {order_details?.address_id?.name}
                        </p>
                       
                        
                        <br />
                        <p class="d-inline">
                          <b>Billing Address:</b>
                        </p>
                        <br />
                        <p class="d-inline">
                          {order_details?.address_id?.address},
                          {order_details?.address_id?.city},
                          {order_details?.address_id?.state}
                          <br />
                          ZIP: {order_details?.address_id?.pincode}
                          <br />
                          Phone: {order_details?.address_id?.phone}
                          <br />
                          E-mail: {order_details?.address_id?.email}
                        </p>
                      </div>
                      <div class="col-sm-6"></div>
                    </div>

                    <br />
                    <div class="row px-5">
                      <div class="col-sm-6">
                        <h3>Payment Details:</h3>
                        <p class="d-inline">
                          <b>Payment Status :</b> <i>Fully Paid</i>
                        </p>
                        <br />
                        <p class="d-inline">
                          <b>Payment Method :</b> wallet
                        </p>
                      </div>
                      <div class="col-sm-6">
                        <h3 class="text-right">Order Date:</h3>
                        <br />
                        <p class="text-right">
                          <b>
                           
                            {moment(productID?.createdAt).format(
                              "  DD MMMM, YYYY"
                            )}
                          </b>
                        </p>
                      </div>
                    </div>

                    

                    <table class="table">
                      <thead>
                        <tr>
                          <th style={{ borderTop: "none" }} scope="col">
                            <h4 class="text-left">
                              <b>Payment invoice</b>
                            </h4>
                          </th>
                          <th style={{ borderTop: "none" }} scope="col"></th>
                          <th style={{ borderTop: "none" }} scope="col"></th>
                          <th style={{ borderTop: "none" }} scope="col"></th>
                          <th style={{ borderTop: "none" }} scope="col"></th>
                          <th style={{ borderTop: "none" }} scope="col"></th>
                        </tr>

                        
                        <tr className="border-bottom fs-6 fw-bold text-muted">
                          <th>S.No</th>
                          <th className="min-w-175px pb-2">Item</th>
                          <th className="min-w-70px text-end pb-2">Color</th>
                          <th className="min-w-70px text-end pb-2">Size</th>
                          <th className="min-w-70px text-end pb-2">
                            Unit Cost
                          </th>
                          <th className="min-w-80px text-end pb-2">Quantity</th>
                          <th className="min-w-100px text-end pb-2">Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {order_details?.orderproductsList &&
                          order_details?.orderproductsList?.map((data, i) => {
                            console.log(data);

                            return (
                              <tr
                                class="text-center"
                                style={{ borderBottom: "2px solid black" }}
                              >
                                <td className="">{i + 1}</td>
                                <td>
                                  <div className="d-flex ">
                                    <div className="">
                                      <div className="fw-bold">
                                        {data?.product_names}
                                      </div>
                                      <div className="fs-7 text-muted">
                                     
                                      </div>
                                    </div>
                                  </div>
                                </td>
                                
                                <td className="text-end">
                                  {" "}
                                  {data?.colorId?.color}
                                </td>
                                <td className="text-end">
                                  {" "}
                                  {data?.sizeId?.size}
                                </td>
                                <td className="text-end">
                                  {" "}
                                  {data?.product_price}
                                </td>
                               
                                <td className="text-end">
                                  {" "}
                                  {data?.itme_count}
                                </td>
                                 
                                <td className="text-end">
                                  ₹ {data?.sub_total}
                                </td>
                               
                              </tr>
                            );
                          })}
                        <tr>
                          <th style={{ border: "none" }}></th>
                          <th style={{ border: "none" }}></th>
                          <th style={{ border: "none" }}></th>
                          <td style={{ border: "none" }}></td>
                          <td style={{ border: "none" }}></td>
                          <td style={{ border: "none" }} class="text-right">
                            <b>Sub Total Amount: </b>
                          </td>
                          <td style={{ border: "none" }} class="text-right">
                            ₹ {order_details?.sub_total}
                          </td>
                        </tr>
                        <tr>
                          <th style={{ border: "none" }}></th>
                          <th style={{ border: "none" }}></th>
                          <th style={{ border: "none" }}></th>
                          <td style={{ border: "none" }}></td>
                          <td style={{ border: "none" }}></td>
                          <td style={{ border: "none" }} class="text-right">
                            <b>Tax:</b>
                          </td>
                          <td style={{ border: "none" }} class="text-right">
                            ₹ {totalSubtotalPricegst}
                          </td>
                        </tr>
                        
                        <tr>
                          <th style={{ border: "none" }}></th>
                          <th style={{ border: "none" }}></th>
                          <th style={{ border: "none" }}></th>
                          <td style={{ border: "none" }}></td>
                          <td style={{ border: "none" }}></td>
                          <td style={{ border: "none" }} class="text-right">
                            <b>Shipping:</b>
                          </td>
                          <td style={{ border: "none" }} class="text-right">
                            ₹ {shippingCharge}
                          </td>
                        </tr>
                        <tr>
                          <th style={{ border: "none" }}></th>
                          <th style={{ border: "none" }}></th>
                          <th style={{ border: "none" }}></th>
                          <th style={{ border: "none" }}></th>
                          <td style={{ border: "none" }}></td>
                          <td style={{ border: "none" }} class="text-right">
                            <b>Grand Total:</b>
                          </td>
                          <td style={{ border: "none" }} class="text-right">
                            ₹ {order_details?.totalAmount}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div className="row">
                      <div className="col-3"></div>
                      <div className="col-9 text-right mb-15 mt-30">
                        <p>
                          This is a computer generated receipt ,no signature
                          required
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
          </Modal.Body>
          <Modal.Footer>
            <ReactToPrint
              trigger={() => (
                <Button variant="primary" onClick={hendleDelete}>
                  Print / Download
                </Button>
                // <button className='bg-blue-500 ml-5 text-white font-bold py-2 px-8 rounded shadow border-2 border-blue-500 hover:bg-transparent hover:text-blue-500 transition-all duration-300'>
                //   Print / Download
                // </button>
              )}
              content={() => componentRef.current}
            />
          </Modal.Footer>
        </Modal>
        <Modal show={showDelelt1} size="lg" onHide={handleCloseDelete}>
          <Modal.Header closeButton>
            <Modal.Title> Invoice</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="container img100" ref={componentRef}>
              <div className="row">
                <div className="col-lg-12">
                  <div className="invoice-inner">
                    <div className="invoice-info" id="invoice_wrapper">
                      <div className="invoice-header">
                        <div className="row invoceCantiner">
                          <div className="col-sm-6">
                            <div className="invoice-numb">
                              <h1 className="invoice-header-1 mb-10 mt-20">
                                Invoice
                                {/* <span className="text-brand">#1970191</span> */}
                              </h1>
                              <h6 className="">
                                Dear, {order_details?.address_id?.name}{" "}
                              </h6>
                              <p>Email : {order_details?.address_id?.email}</p>
                              <p>Number : {order_details?.address_id?.phone}</p>
                              <p>
                                Billing Address :{" "}
                                {order_details?.user_id?.address1},{" "}
                                {order_details?.user_id?.zip}
                              </p>
                              <p>
                                Shipping Address :{" "}
                                {order_details?.address_id?.address}
                              </p>
                              <p>City : {order_details?.address_id?.city}</p>
                              <p>State : {order_details?.address_id?.state}</p>
                              <p>
                                Pincode : {order_details?.address_id?.pincode}
                              </p>
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="invoice-name text-end">
                              <div>
                                <div className="logo text-end mt-20">
                                  {/* <a href="index.html"> */}
                                  <img
                                    src={
                                      URL.API_BASE_URL +
                                      get_footer_all_data?.socialIcon
                                        ?.invoiceLogo
                                    }
                                    alt="logo"
                                  />
                                  {/* </a> */}
                                </div>

                                <p className="text-sm text-mutted">
                                  {get_footer_all_data?.socialIcon?.companyName}
                                </p>
                                <p className="text-sm text-mutted">
                                  {get_footer_all_data?.socialIcon?.email}
                                </p>
                                <p className="text-sm text-mutted">
                                  {get_footer_all_data?.socialIcon?.address}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="invoice-top">
                        <div className="row">
                          <div className="col-lg-9 col-md-6">
                            {/* <div className="invoice-number">
                              <h4 className="invoice-title-1 mb-10">Invoice To</h4>
                              <p className="invoice-addr-1">
                                <strong>AliThemes Pty Ltd</strong> <br />
                                contactalithemes.com <br />
                                PO Box 16122, Collins Street West, <br />
                                Australia
                              </p>
                            </div> */}
                          </div>
                          <div className="col-lg-3 col-md-6">
                            {/* <div className="invoice-number">
                              <h4 className="invoice-title-1 mb-10">Bill To</h4>
                              <p className="invoice-addr-1">
                                <strong>NestMart Inc</strong> <br />
                                billing@NestMart.com <br />
                                205 North Michigan Avenue, <br />
                                Suite 810 Chicago, 60601, USA
                              </p>
                            </div> */}
                          </div>
                        </div>
                        <div className="row mt-2">
                          <div className="col-lg-9 col-md-6">
                            <h4 className="invoice-title-1 mb-10">
                              {/* Dear, {productID?.userName}{" "} */}
                            </h4>
                            {/* <p className="invoice-from-1">30 November 2022</p> */}
                          </div>
                          <div className="col-lg-3 col-md-6">
                            {/* <h4 className="invoice-title-1 mb-10">
                              Payment Method
                            </h4>
                            <p className="invoice-from-1">Via Paypal</p> */}
                          </div>
                        </div>
                        <div className="row mt-2">
                          <div className="col-lg-9 col-md-6">
                            <h4 className="invoice-title-1 mb-10">Order Id</h4>
                            <p className="invoice-from-1">{productID?._id}</p>
                          </div>
                          <div className="col-lg-3 col-md-6">
                            <h4 className="invoice-title-1 mb-10">Date</h4>
                            <p className="invoice-from-1">
                              {" "}
                              {/* {dateFormat(productID?.createdAt, " d mmm yyyy")} */}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="invoice-center">
                        <div className="table-responsive">
                          <table className="table table-striped invoice-table">
                            <thead className="bg-active">
                              <tr>
                                <th>S.No</th>
                                <th>Item</th>
                                <th>Color</th>
                                <th>Size</th>
                                <th className="text-center">Unit Cost </th>
                                <th className="text-center">Quantity</th>
                                <th className="text-right">Amount</th>
                              </tr>
                            </thead>
                            <tbody>
                              {/* productID */}

                              {order_details?.orderproductsList &&
                                order_details?.orderproductsList?.map(
                                  (data, i) => {
                                    return (
                                      <tr key={i}>
                                        <td className="">{i + 1}</td>
                                        <td>
                                          <div className="item-desc-1">
                                            <span>{data?.product_names}</span>
                                            {/* <small>SKU: FWM15VKT</small> */}
                                          </div>
                                        </td>
                                        <td className="text-center">
                                          {data?.colorId?.color}
                                        </td>
                                        <td className="text-center">
                                          {data?.sizeId?.size}
                                        </td>
                                        <td className="text-center">
                                          {data?.product_price}
                                        </td>
                                        <td className="text-center">
                                          {data?.itme_count}
                                        </td>
                                        <td className="text-right">
                                          ₹{data?.sub_total}
                                        </td>
                                      </tr>
                                    );
                                  },
                                )}

                              <tr>
                                <td colspan="6" className="text-end f-w-600">
                                  SubTotal
                                </td>
                                <td className="text-right">
                                  ₹{order_details?.sub_total}
                                </td>
                              </tr>
                              <tr>
                                <td colspan="6" className="text-end f-w-600">
                                  Shipping
                                </td>
                                <td className="text-right">
                                  ₹{shippingCharge}
                                </td>
                              </tr>
                              <tr>
                                <td colspan="6" className="text-end f-w-600">
                                  Gst
                                </td>
                                <td className="text-right">
                                  ₹{totalSubtotalPricegst}
                                </td>
                              </tr>
                              <tr>
                                <td colspan="6" className="text-end f-w-600">
                                  Grand Total
                                </td>
                                <td className="text-right f-w-600">
                                  ₹{order_details?.totalAmount}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div className="invoice-bottom">
                        <div className="row invoceCantiner1">
                          <div className="col-sm-6">
                            {/* <div>
                              <h3 className="invoice-title-1">Important Note</h3>
                              <ul className="important-notes-list-1">
                                <li>
                                  All amounts shown on this invoice are in US
                                  dollars
                                </li>
                                <li>
                                  finance charge of 1.5% will be made on unpaid
                                  balances after 30 days.
                                </li>
                                <li>Once order done, money can't refund</li>
                                <li>
                                  Delivery might delay due to some external
                                  dependency
                                </li>
                              </ul>
                            </div> */}
                          </div>
                          <div className="col-sm-6 col-offsite">
                            <div className="text-end">
                              <p className="mb-0 text-13">
                                THANKS FOR PURCHASING WITH Ril India
                              </p>
                              <p>
                                {/* <strong> {get_invoice?.name}</strong> */}
                              </p>
                              {/* <div className="mobile-social-icon mt-50 print-hide">
                                <h6>Follow Us</h6>
                                <a href="#">
                                  <img
                                    src="/assets/imgs/theme/icons/icon-facebook-white.svg"
                                    alt=""
                                  />
                                </a>
                                <a href="#">
                                  <img
                                    src="/assets/imgs/theme/icons/icon-twitter-white.svg"
                                    alt=""
                                  />
                                </a>
                                <a href="#">
                                  <img
                                    src="/assets/imgs/theme/icons/icon-instagram-white.svg"
                                    alt=""
                                  />
                                </a>
                                <a href="#">
                                  <img
                                    src="/assets/imgs/theme/icons/icon-pinterest-white.svg"
                                    alt=""
                                  />
                                </a>
                                <a href="#">
                                  <img
                                    src="/assets/imgs/theme/icons/icon-youtube-white.svg"
                                    alt=""
                                  />
                                </a>
                              </div> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <div className="invoice-btn-section clearfix d-print-none">
                      <a
                        href="javascript:window.print()"
                        className="btn btn-lg btn-custom btn-print hover-up"
                      >
                        {" "}
                        <img
                          src="assets/imgs/theme/icons/icon-print.svg"
                          alt=""
                        />{" "}
                        Print{" "}
                      </a>
                      <a
                        id="invoice_download_btn"
                        className="btn btn-lg btn-custom btn-download hover-up"
                      >
                        {" "}
                        <img
                          src="assets/imgs/theme/icons/icon-download.svg"
                          alt=""
                        />{" "}
                        Download{" "}
                      </a>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <ReactToPrint
              trigger={() => (
                <Button variant="primary" onClick={hendleDelete}>
                  Print / Download
                </Button>
                // <button className='bg-blue-500 ml-5 text-white font-bold py-2 px-8 rounded shadow border-2 border-blue-500 hover:bg-transparent hover:text-blue-500 transition-all duration-300'>
                //   Print / Download
                // </button>
              )}
              content={() => componentRef.current}
            />

            {/* <Button variant="secondary" onClick={handleCloseDelete}>
              No
            </Button>
            <Button variant="primary" onClick={hendleDelete}>
              Yes
            </Button> */}
          </Modal.Footer>
        </Modal>

        <section className="content-main">
          <div className="content-header">
            <div>
              <h2 className="content-title card-title">Orders</h2>
              {/* <p>Lorem ipsum dolor sit amet.</p> */}
            </div>
            <div>
              {/* <a href="#" className="btn btn-light rounded font-md">Export</a>
                      <a href="#" className="btn btn-light rounded font-md">Import</a> */}
              {/* <a href="#" className="btn btn-primary btn-sm rounded">
              Create new
            </a> */}

              {/* <Button variant="primary" onClick={handleShow}>
                Create Product
              </Button> */}
            </div>
          </div>
          <div className="card mb-4">
            <header className="card-header1">
              <div className="row align-items-center">
                {/* <div className="col col-check flex-grow-0">
                <div className="form-check ms-2">
                  <input className="form-check-input" type="checkbox" value="" />
                </div>
              </div> */}
                <div className="col-md-3 col-12 me-auto mb-md-0 mb-3">
                  {/* <span className='svg-icon svg-icon-1 position-absolute ms-6'>
                    <svg
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <rect
                        opacity='0.5'
                        x='17.0365'
                        y='15.1223'
                        width='8.15546'
                        height='2'
                        rx='1'
                        transform='rotate(45 17.0365 15.1223)'
                        fill='currentColor'
                      />
                      <path
                        d='M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z'
                        fill='currentColor'
                      />
                    </svg>
                  </span> */}
                  {/* <!--end::Svg Icon-->  */}
                  {/* <input
                    type="text"
                    data-kt-permissions-table-filter="search"
                    className="form-control form-control-solid w-250px ps-15"
                    placeholder="Search Product"
                    onChange={(e) => {
                      hendleSearch(e.target.value);
                    }}
                  /> */}
                  {/* <select className="form-select">
                                  <option selected>All category</option>
                                  <option>Electronics</option>
                                  <option>Clothes</option>
                                  <option>Automobile</option>
                              </select> */}
                </div>
                <div className="col-md-2 col-6">
                  {/* <input type="date" value="02.05.2021" className="form-control" /> */}
                </div>
                <div className="col-md-2 col-6">
                  {/* <select className="form-select">
                  <option selected>Status</option>
                  <option>Active</option>
                  <option>Disabled</option>
                  <option>Show all</option>
                </select> */}
                </div>
              </div>
            </header>

            <div className="card-body">
              <table>
                <thead>
                  <tr>
                    <th>S.No.</th>
                    <th>Sale Code</th>
                    <th>Date</th>
                    <th>total</th>
                    <th> Grand Amount</th>
                    <th> Payment Status</th>
                    <th>Delivery Status</th>
                    <th>Order return</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {commentsData &&
                    commentsData.map((data, i) => {
                      const nextMonthStart = moment(data?.createdAt)
                        .add(1, "month")
                        .toDate();
                      const formetCahnge =
                        moment(nextMonthStart).format("DD MMM yyyy");
                      {
                        /* const shippingCharge = data?.totalAmount > 8100 ? 0 : 100; */
                      }
                      const shippingChargelist =
                        data?.sub_total > 10000 ? 699 : 199;
                      return (
                        <tr key={i}>
                          <td>{(page - 1) * 10 + i + 1}</td>
                          <td>{data?.sellCode}</td>
                          <td style={{ minWidth: "150px" }}>
                            {moment(data?.createdAt).format("DD MMM yyyy")}
                          </td>
                          <td>{data?.sub_total}</td>
                          <td>{data?.totalAmount}</td>
                          {/* <td>{data?.totalAmount + shippingChargelist}</td> */}
                          <td>{data?.payment_mode_name}</td>
                          <td>{data?.delivery_status}</td>
                          <td>{data?.sale_refund == "1" ? "Yes" : "No"}</td>
                          <td>
                            <a
                              // href="#"
                              onClick={() => {
                                hendleModalShow(data);
                              }}
                              className="btn btn-sm font-sm btn-light rounded"
                            >
                              Invoice{" "}
                            </a>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>

              {get_seller_product_list?.totalDocs == "0" && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "400px",
                  }}
                >
                  <h3>Record Not found</h3>
                </div>
              )}
            </div>
          </div>

          <div className="pagination-area mt-30 mb-50">
            <ReactPaginate
              breakLabel="..."
              nextLabel=" >"
              className="dataTables_paginate paging_simple_numbers category"
              onPageChange={handlePageClick}
              pageRangeDisplayed={2}
              pageCount={pageCount}
              previousLabel="<"
              renderOnZeroPageCount={null}
            />
            {/* <nav aria-label="Page navigation example">
            <ul className="pagination justify-content-start">
              <li className="page-item active">
                <a className="page-link" href="#">
                  01
                </a>
              </li>
              <li className="page-item">
                <a className="page-link" href="#">
                  02
                </a>
              </li>
              <li className="page-item">
                <a className="page-link" href="#">
                  03
                </a>
              </li>
              <li className="page-item">
                <a className="page-link dot" href="#">
                  ...
                </a>
              </li>
              <li className="page-item">
                <a className="page-link" href="#">
                  16
                </a>
              </li>
              <li className="page-item">
                <a className="page-link" href="#">
                  <i className="material-icons md-chevron_right"></i>
                </a>
              </li>
            </ul>
          </nav> */}
          </div>
        </section>
      </main>
    </div>
  );
}

export default Order;
